import { REPLY_EDITOR_MODES } from 'dashboard/components/widgets/WootWriter/constants';

// Aceleres: o formato da chave do rascunho estava escrito à mão em mais de um
// ponto do ReplyBox. Agora a lista de conversas também precisa ler o mesmo
// registro para mostrar "Rascunho: ...", então o formato mora num lugar só.
export const buildDraftKey = (conversationId, replyType) =>
  `draft-${conversationId}-${replyType}`;

// Uma conversa pode ter rascunho na resposta e na nota interna ao mesmo tempo.
export const DRAFT_REPLY_TYPES = [
  REPLY_EDITOR_MODES.REPLY,
  REPLY_EDITOR_MODES.NOTE,
];

// Anexo já enviado ao ActiveStorage chega como blob (content_type/filename);
// o arquivo cru do input chega como File (type/name). Os dois formatos
// convivem na bandeja, então a leitura aceita ambos.
const resourceType = resource => resource?.content_type || resource?.type || '';
const resourceName = resource => resource?.filename || resource?.name || '';

// Mesma deteção do AttachmentsPreview: o MIME manda e a extensão desempata,
// porque anexo de resposta rápida pode chegar sem content_type.
export const draftAttachmentKind = attachment => {
  if (attachment?.isRecordedAudio) return 'audio';

  const resource = attachment?.resource || {};
  const type = resourceType(resource).toLowerCase();
  const name = resourceName(resource);

  if (
    type.includes('image') ||
    /\.(avif|gif|jpe?g|png|svg|webp)$/i.test(name)
  ) {
    return 'image';
  }
  if (type.includes('video') || /\.(m4v|mov|mp4|webm)$/i.test(name)) {
    return 'video';
  }
  if (type.includes('audio') || /\.(aac|m4a|mp3|ogg|wav)$/i.test(name)) {
    return 'audio';
  }

  return 'file';
};

// Prefixo e rótulos do rascunho na lista, no formato que o WhatsApp usa.
export const DRAFT_PREFIX_LABEL = 'Rascunho:';

export const DRAFT_ATTACHMENT_LABELS = {
  image: 'Foto',
  video: 'Vídeo',
  audio: 'Áudio',
  file: 'Documento',
};
